import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import Alert from "../../components/Alert";
import { Link } from "react-router-dom";
import { loadAccounts, loadGrn } from "../../redux/actions/tally";
import ServerPaginationTable from "../../components/ServerPaginationTable";
import SyncStatus from "../../components/SyncStatus";
import { migrateTallyGRNData, migrateGRNToTally } from "../../api/index";
import SyncRemarkRender from "../../components/SyncRemarkRender";

const columns = [
  {
    Header: "Voucher ID",
    accessor: "cartNoteId",
  },
  {
    Header: "Voucher Number",
    accessor: "cartNoteSequenceCode",
  },
  {
    Header: "Voucher Date",
    accessor: "noteDate",
  },
  {
    Header: "Deskera ID",
    accessor: "deskeraId",
  },
  {
    Header: "Deskera Sequence Code",
    accessor: "deskeraDocumentSequenceCode",
  },
  {
    Header: "Sync Status",
    accessor: "syncStatus",
    Cell: ({ cell: { row } }) => {
      return (
        <SyncStatus
          status={row.original.syncStatus}
          reason={row.original.reason}
          id={row.original.cartProductId}
        />
      );
    },
  },
  {
    Header: "Sync Remarks",
    accessor: "reason",
    disableSortBy: true,
    Cell: ({ cell: { row } }) => {
      let value =
        row.original?.syncStatus !== "SUCCESSFUL" && row.original?.reason
          ? row.original?.reason
          : "";
      return <SyncRemarkRender value={value} id={row.original.id.toString()} />;
    },
  },
];

function GoodsReceiptNotes() {
  const tallyConfig = useSelector((state) => state.tally.accounts);
  const grnData = useSelector((state) => {
    return state.tally.grnData;
  });
  const dispatch = useDispatch();
  const [pageCount, setPageCount] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    dispatch(loadAccounts());
    dispatch(loadGrn());
  }, []);

  const data = useMemo(() => grnData.data, [grnData]);

  useEffect(() => {
    setLoading(false);
    if (grnData && grnData?.data?.totalPages) {
      setPageCount(grnData?.data?.totalPages);
    }
  }, [grnData]);

  const refreshData = ({ pageSize, pageIndex, status, sortBy, search }) => {
    setLoading(true);
    dispatch(loadGrn(pageSize, pageIndex, status, sortBy, search ?? ""));
  };

  return (
    <>
      <div className='p-4'>
        <h3 className='mb-3'>Goods Receipt Notes</h3>
        {!tallyConfig.data ||
          (!tallyConfig.data.syncEnable && (
            <Alert type='warning'>
              Your synced Goods Receipt Notes Vouchers will appear here. Please
              complete{" "}
              <Link to='/app/tally' className='text-alert-warning'>
                <u>Setup</u>
              </Link>{" "}
              before continuing.
            </Alert>
          ))}
        <ServerPaginationTable
          data={data.content ? data.content : []}
          columns={columns}
          migrate={migrateTallyGRNData}
          syncToTally={migrateGRNToTally}
          cart='tally'
          refresh={refreshData}
          tab='Goods Receipt Notes'
          pageCount={pageCount}
          loading={loading}
          rowId='id'
        />
      </div>
    </>
  );
}

export default GoodsReceiptNotes;
